import { Button, Divider, FormControl, FormControlLabel, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import { radioColorSx, radioOptionArray, relationArray } from 'store/constant';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import axiosInstance from 'custom-axios';
import { ToastContainer, toast } from 'react-toastify';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import DeleteIcon from '@mui/icons-material/Delete';
import NumberFormat from 'react-number-format';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import AddIcon from '@mui/icons-material/Add';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';


const BeneficiaryInformation = ({ beneficiaryRef, accountTypeId, formAccountData, userId, setFormAccountData, activeAccountStep, setActiveAccountStep }) => {

    const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [beneficiaryData, setBeneficiaryData] = useState();
    const [accountMemberData, setAccountMemberData] = useState([]);
    const [contingentAccountMemberData, setContingentAccountMemberData] = useState([]);
    // const [accountTypeId, setAccountTypeId] = useState(1)
    // const [showAccountBeneficiaryDetails, setShowAccountBeneficiaryDetails] = useState(false);
    // const [showContingentBeneficiaryDetails, setShowContingentBeneficiaryDetails] = useState(false);
    // const [allocationError, setAllocationError] = useState('');
    // const [contingentAllocationError, setContingentAllocationError] = useState('');

    /* const [accountTypedDetails, setAccountTypeDetails] = useState({
        register_account: formAccountData.updated_register_accounts,
        non_register_account: formAccountData.updated_non_register_accounts,
    }) */

    /* const validationSchema = Yup.object().shape({
        elect_account_beneficiary: Yup.string().required(),
        elect_contingent_beneficiary: Yup.string().required(),
    }); */

    const {
        register,
        handleSubmit,
        setValue,
        trigger,
        control,
        formState: { errors }
    } = useFormContext();


    React.useImperativeHandle(beneficiaryRef, () => ({
        triggerValidation: async () => {

            const isValid = await trigger();

            return isValid;
        }
    }));

    const fetchBeneficiaryData = async () => {

        try {
            const response = await axiosInstance.get(`api/get-user-beneficiary-info/${userId}`);

            if (response.data) {

                const filteredData = response.data?.elect_account_beneficiary_details[0]?.details.map(({ id, first_name, last_name }) => ({
                    id,
                    first_name,
                    last_name,
                    full_name: `${first_name} ${last_name}`
                }));

                // Update state
                setAccountMemberData(filteredData);


                const filteredContingentData = response.data?.elect_contingent_account_beneficiary_details[0]?.details.map(({ id, first_name, last_name }) => ({
                    id,
                    first_name,
                    last_name,
                    full_name: `${first_name} ${last_name}`
                }));

                // Update state
                setContingentAccountMemberData(filteredContingentData);

                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    ...response.data,
                }));

                setBeneficiaryData(prevFormData => ({
                    ...prevFormData,
                    ...response.data,
                }));

                // setShowAccountBeneficiaryDetails(response.data.elect_account_beneficiary == 1)
                // setShowContingentBeneficiaryDetails(response.data.elect_contingent_beneficiary == 1)

                setValue('elect_account_beneficiary', response.data.elect_account_beneficiary)
                setValue('elect_contingent_beneficiary', response.data.elect_contingent_beneficiary)
            }

        } catch (error) {
            // console.error(error.message);
        }
    }

    const handleChange = (e, beneDetailsType) => {
        const { name, value } = e.target;

        setBeneficiaryData((prevData) => {
            const shouldClear = value !== "1"; // If value is not '1', clear the data
            return {
                ...prevData,
                [name]: value, // Update the selected value

                [beneDetailsType]: shouldClear
                    ? prevData[beneDetailsType].length > 0
                        ? [
                            {
                                primary_reg_count: prevData[beneDetailsType][0]?.primary_reg_count,
                                primary_non_reg_count: prevData[beneDetailsType][0]?.primary_non_reg_count,
                                spousal_reg_count: prevData[beneDetailsType][0]?.spousal_reg_count,
                                spousal_non_reg_count: prevData[beneDetailsType][0]?.spousal_non_reg_count,
                                id: prevData[beneDetailsType][0]?.id || "",

                                primary: prevData[beneDetailsType][0]?.primary.map(primaryItem => ({
                                    bene_non_register_account_type: primaryItem.bene_non_register_account_type.map(account => ({
                                        ...account,
                                        account_checked: false // Only account_checked is set to false
                                    })),
                                    bene_register_account_type: primaryItem.bene_register_account_type.map(account => ({
                                        ...account,
                                        account_checked: false // Only account_checked is set to false
                                    }))
                                })) || [],

                                spouse: prevData[beneDetailsType][0]?.spouse.map(spouseItem => ({
                                    bene_non_register_account_type: spouseItem.bene_non_register_account_type.map(account => ({
                                        ...account,
                                        account_checked: false // Only account_checked is set to false
                                    })),
                                    bene_register_account_type: spouseItem.bene_register_account_type.map(account => ({
                                        ...account,
                                        account_checked: false // Only account_checked is set to false
                                    }))
                                })) || [],

                                details: prevData[beneDetailsType][0]?.details.map(detailItem => ({
                                    id: detailItem.id || "",
                                    first_name: "",
                                    last_name: "",
                                    middle_name: "",
                                    sin: "",
                                    dob: "",
                                    allocation: "",
                                    relation: "",
                                    selected_beneficiary_member: ""
                                })) || []
                            }
                        ]
                        : [] // Ensure empty array if there were no initial details
                    : prevData[beneDetailsType] // Retain existing data if value is '1'
            };
        });

        setFormAccountData((prevData) => {
            const updatedData = { ...prevData, [name]: value };
            return updatedData;
        });
    };

    const handleInputChange = (mainIndex, index, field, value) => {
        const updatedDetails = [...beneficiaryData.elect_account_beneficiary_details];

        updatedDetails[mainIndex].details[index][field] = value;

        setBeneficiaryData({
            ...beneficiaryData,
            elect_account_beneficiary_details: updatedDetails,
        });
    };


    const handleChangeAccountMember = (mainIndex, index, field, memberId) => {

        const result = beneficiaryData.elect_account_beneficiary_details[0].details?.find(row => row.id === memberId);

        if (result) {

            handleInputChange(mainIndex, index, field, memberId)

            setBeneficiaryData(prevState => {
                const newData = { ...prevState };

                newData.elect_account_beneficiary_details[mainIndex].details[index] = {
                    ...newData.elect_account_beneficiary_details[mainIndex].details[index],
                    ...result,
                    id: newData.elect_account_beneficiary_details[mainIndex].details[index].id,
                    selected_beneficiary_member: memberId
                };

                return newData;
            });
        }
    }


    const handleChangeContingentAccountMember = (mainIndex, index, field, memberId) => {

        const result = beneficiaryData.elect_contingent_account_beneficiary_details[0].details?.find(row => row.id === memberId);

        if (result) {

            handleContingentInputChange(mainIndex, index, field, memberId)

            setBeneficiaryData(prevState => {
                const newData = { ...prevState };

                newData.elect_contingent_account_beneficiary_details[mainIndex].details[index] = {
                    ...newData.elect_contingent_account_beneficiary_details[mainIndex]?.details[index],
                    ...result,
                    id: newData.elect_contingent_account_beneficiary_details[mainIndex]?.details[index].id,
                    selected_beneficiary_member: memberId
                };
                return newData;
            });
        }
    }

    const handleContingentInputChange = (mainIndex, index, field, value) => {
        const updatedDetails = [...beneficiaryData.elect_contingent_account_beneficiary_details];
        updatedDetails[mainIndex].details[index][field] = value;
        setBeneficiaryData({
            ...beneficiaryData,
            elect_contingent_account_beneficiary_details: updatedDetails,
        });
    };

    const handleAccountTypeChange = (type, category, idx, accountIdx, mainIndex) => {
        const updatedDetails = [...beneficiaryData.elect_account_beneficiary_details];
        const account = updatedDetails[mainIndex][type][idx][category][accountIdx];

        account.account_checked = !account.account_checked;

        setBeneficiaryData({
            ...beneficiaryData,
            elect_account_beneficiary_details: updatedDetails,
        });
    };

    const handleContingentAccountTypeChange = (e, type, category, idx, accountIdx, mainIndex) => {
        const updatedDetails = [...beneficiaryData.elect_contingent_account_beneficiary_details];
        const account = updatedDetails[mainIndex][type][idx][category][accountIdx];

        account.account_checked = e.target.checked;

        setBeneficiaryData({
            ...beneficiaryData,
            elect_contingent_account_beneficiary_details: updatedDetails,
        });
    };


    const handleBeneficiaryDateChange = (mainIndex, newValue, index) => {

        const updatedDetails = [...beneficiaryData.elect_account_beneficiary_details];

        updatedDetails[mainIndex].details[index]['dob'] = newValue;

        setBeneficiaryData({
            ...beneficiaryData,
            elect_account_beneficiary_details: updatedDetails,
        });
    };


    const handleContingentBeneficiaryDateChange = (mainIndex, newValue, index) => {

        const updatedDetails = [...beneficiaryData.elect_contingent_account_beneficiary_details];

        updatedDetails[mainIndex].details[index]['dob'] = newValue;

        setBeneficiaryData({
            ...beneficiaryData,
            elect_contingent_account_beneficiary_details: updatedDetails,
        });
    };


    // Allocation Handler (called on allocation change)
    const handleAllocationChange = (mainIndex, values, index) => {
        handleInputChange(mainIndex, index, 'allocation', values.floatValue || 0);
    };

    const handleContingentAllocationChange = (mainIndex, values, index) => {
        handleContingentInputChange(mainIndex, index, 'allocation', values.floatValue || 0);
    };

    const addAccountBeneficiary = () => {

        setBeneficiaryData((prevData) => {

            const newBeneficiary = {
                primary_reg_count: 0,
                primary_non_reg_count: 0,
                spousal_reg_count: 0,
                spousal_non_reg_count: 0,
                id: '',
                // account_beneficiary_count: (prevData.elect_account_beneficiary_details.length + 1),
                primary: [],
                spouse: [],
                details: [
                    {
                        id: (prevData.elect_account_beneficiary_details.length + 1).toString(),
                        first_name: "",
                        last_name: "",
                        middle_name: "",
                        sin: "",
                        dob: "",
                        allocation: "",
                        relation: "",
                        selected_beneficiary_member: "",
                    },
                ],
            };

            // Check if there are existing beneficiaries
            if (prevData.elect_account_beneficiary_details.length > 0) {
                const lastBeneficiary = prevData.elect_account_beneficiary_details[prevData.elect_account_beneficiary_details.length - 1];

                // Clone primary accounts dynamically
                if (lastBeneficiary.primary.length > 0) {
                    newBeneficiary.primary = lastBeneficiary.primary.map((p) => ({
                        ...p,
                        bene_non_register_account_type: p.bene_non_register_account_type.map((acc) => ({ ...acc, account_checked: false })),
                        bene_register_account_type: p.bene_register_account_type.map((acc) => ({ ...acc, account_checked: false })),
                    }));
                    newBeneficiary.primary_reg_count = lastBeneficiary.primary_reg_count;
                    newBeneficiary.primary_non_reg_count = lastBeneficiary.primary_non_reg_count;
                }

                // Clone spouse accounts dynamically
                if (lastBeneficiary.spouse.length > 0) {
                    newBeneficiary.spouse = lastBeneficiary.spouse.map((s) => ({
                        ...s,
                        bene_non_register_account_type: s.bene_non_register_account_type.map((acc) => ({ ...acc, account_checked: false })),
                        bene_register_account_type: s.bene_register_account_type.map((acc) => ({ ...acc, account_checked: false })),
                    }));
                    newBeneficiary.spousal_reg_count = lastBeneficiary.spousal_reg_count;
                    newBeneficiary.spousal_non_reg_count = lastBeneficiary.spousal_non_reg_count;
                }
            }

            return {
                ...prevData,
                elect_account_beneficiary_details: [...prevData.elect_account_beneficiary_details, newBeneficiary],
            };
        });
    };

    const addContingentAccountBeneficiary = () => {
        setBeneficiaryData((prevData) => {
            const newBeneficiary = {
                primary_reg_count: 0,
                primary_non_reg_count: 0,
                spousal_reg_count: 0,
                spousal_non_reg_count: 0,
                id: '',
                // contingent_beneficiary_count: (prevData.elect_contingent_account_beneficiary_details.length + 1).toString(),
                primary: [],
                spouse: [],
                details: [
                    {
                        id: (prevData.elect_contingent_account_beneficiary_details.length + 1).toString(),
                        first_name: "",
                        last_name: "",
                        middle_name: "",
                        sin: "",
                        dob: "",
                        allocation: "",
                        relation: "",
                        selected_beneficiary_member: "",
                    },
                ],
            };

            // Check if there are existing beneficiaries
            if (prevData.elect_contingent_account_beneficiary_details.length > 0) {
                const lastBeneficiary = prevData.elect_contingent_account_beneficiary_details[prevData.elect_contingent_account_beneficiary_details.length - 1];

                // Clone primary accounts dynamically
                if (lastBeneficiary.primary.length > 0) {
                    newBeneficiary.primary = lastBeneficiary.primary.map((p) => ({
                        ...p,
                        bene_non_register_account_type: p.bene_non_register_account_type.map((acc) => ({ ...acc, account_checked: false })),
                        bene_register_account_type: p.bene_register_account_type.map((acc) => ({ ...acc, account_checked: false })),
                    }));
                    newBeneficiary.primary_reg_count = lastBeneficiary.primary_reg_count;
                    newBeneficiary.primary_non_reg_count = lastBeneficiary.primary_non_reg_count;
                }

                // Clone spouse accounts dynamically
                if (lastBeneficiary.spouse.length > 0) {
                    newBeneficiary.spouse = lastBeneficiary.spouse.map((s) => ({
                        ...s,
                        bene_non_register_account_type: s.bene_non_register_account_type.map((acc) => ({ ...acc, account_checked: false })),
                        bene_register_account_type: s.bene_register_account_type.map((acc) => ({ ...acc, account_checked: false })),
                    }));
                    newBeneficiary.spousal_reg_count = lastBeneficiary.spousal_reg_count;
                    newBeneficiary.spousal_non_reg_count = lastBeneficiary.spousal_non_reg_count;
                }
            }

            return {
                ...prevData,
                elect_contingent_account_beneficiary_details: [...prevData.elect_contingent_account_beneficiary_details, newBeneficiary],
            };
        });
    };


    const addAccountBeneficiaryDetails = (mainIndex) => {

        const newDetail = {
            first_name: "",
            last_name: "",
            middle_name: "",
            sin: "",
            dob: "",
            allocation: "",
            relation: "",
            selected_beneficiary_member: "",
        };
        const updatedDetails = [...beneficiaryData.elect_account_beneficiary_details];

        updatedDetails[mainIndex].details.push(newDetail); // Add only new detail, no accounts

        setBeneficiaryData({
            ...beneficiaryData,
            elect_account_beneficiary_details: updatedDetails,
        });
    }

    const addContingentBeneficiaryDetails = (mainIndex) => {

        const newDetail = {
            first_name: "",
            last_name: "",
            middle_name: "",
            sin: "",
            dob: "",
            allocation: "",
            relation: "",
            selected_beneficiary_member: "",
        };
        const updatedDetails = [...beneficiaryData.elect_contingent_account_beneficiary_details];

        updatedDetails[mainIndex].details.push(newDetail); // Add only new detail, no accounts

        setBeneficiaryData({
            ...beneficiaryData,
            elect_contingent_account_beneficiary_details: updatedDetails,
        });
    }

    const removeAccountBeneficiary = async (beneficiaryIndex, id) => {

        if (id) {

            const result = await showConfirmSweetAlert({
                title: 'Delete Beneficiary?',
                text: 'Are you sure you want to delete this beneficiary?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                try {
                    const response = await axiosInstance.delete(`api/delete-beneficiary-details/${id}/1`);

                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi()

                    } else {
                        toast.error('Something went wrong.')
                    }

                } catch (error) {
                    toast.error(error.message)
                    // console.error(error)
                } finally {
                    hideLoader();
                }
            }
        } else {

            setBeneficiaryData((prevData) => {
                const updatedDetails = [...prevData.elect_account_beneficiary_details]; // Clone the array

                if (updatedDetails.length > 1) {
                    updatedDetails.splice(beneficiaryIndex, 1); // Remove the entire beneficiary object at the given index
                }

                return {
                    ...prevData,
                    elect_account_beneficiary_details: updatedDetails,
                };
            });
        }
    };

    const removeContingentAccountBeneficiary = async (beneficiaryIndex, id) => {

        if (id) {

            const result = await showConfirmSweetAlert({
                title: 'Delete Beneficiary?',
                text: 'Are you sure you want to delete this beneficiary?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });
            if (result.isConfirmed) {
                try {
                    const response = await axiosInstance.delete(`api/delete-beneficiary-account/${id}`);

                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi()

                    } else {
                        toast.error('Something went wrong.')
                    }

                } catch (error) {
                    toast.error(error.message)
                    // console.error(error)
                } finally {
                    hideLoader();
                }
            }
        } else {

            setBeneficiaryData((prevData) => {
                const updatedDetails = [...prevData.elect_contingent_account_beneficiary_details]; // Clone the array

                if (updatedDetails.length > 1) {
                    updatedDetails.splice(beneficiaryIndex, 1); // Remove the entire beneficiary object at the given index
                }

                return {
                    ...prevData,
                    elect_contingent_account_beneficiary_details: updatedDetails,
                };
            });
        }
    };


    const removeAccountMember = async (id, mainIndex, detailsIndex) => {

        if (id) {
            const result = await showConfirmSweetAlert({
                title: 'Delete Beneficiary?',
                text: 'Are you sure you want to delete this beneficiary?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                try {
                    const response = await axiosInstance.delete(`api/delete-beneficiary-member/${id}`);

                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi()

                    } else {
                        toast.error('Something went wrong.')
                    }

                } catch (error) {
                    toast.error(error.message)
                    // console.error(error)
                } finally {
                    hideLoader();
                }
            }
        } else {
            setBeneficiaryData((prevData) => {
                const updatedDetails = [...prevData.elect_account_beneficiary_details];

                if (updatedDetails[mainIndex]?.details?.length > 1) {
                    updatedDetails[mainIndex].details.splice(detailsIndex, 1); // Remove the specific detail
                } else {
                    // If only one detail remains, remove the entire beneficiary entry
                    updatedDetails.splice(mainIndex, 1);
                }

                return {
                    ...prevData,
                    elect_account_beneficiary_details: updatedDetails,
                };
            });
        }
    }

    const removeContingentAccountMember = async (id, mainIndex, detailsIndex) => {

        if (id) {
            const result = await showConfirmSweetAlert({
                title: 'Delete Beneficiary?',
                text: 'Are you sure you want to delete this beneficiary?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {
                try {
                    const response = await axiosInstance.delete(`api/delete-beneficiary-member/${id}`);

                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi()

                    } else {
                        toast.error('Something went wrong.')
                    }

                } catch (error) {
                    toast.error(error.message)
                    // console.error(error)
                } finally {
                    hideLoader();
                }
            }
        } else {

            setBeneficiaryData((prevData) => {
                const updatedDetails = [...prevData.elect_contingent_account_beneficiary_details]; // Clone the array

                if (updatedDetails[mainIndex]?.details?.length > 1) {
                    updatedDetails[mainIndex].details.splice(detailsIndex, 1); // Remove the specific detail
                } else {
                    // If only one detail remains, remove the entire beneficiary entry
                    updatedDetails.splice(mainIndex, 1);
                }

                return {
                    ...prevData,
                    elect_contingent_account_beneficiary_details: updatedDetails,
                };
            });
        }
    }


    const validateAllocations = (accountDetails, index, type) => {

        const beneficiaryType = type == 1 ? 'account' : 'contingent'

        const totalAllocation = accountDetails.reduce((total, beneficiary) => total + parseFloat(beneficiary.allocation || 0), 0);

        if (totalAllocation != 100) {
            toast.error(`Total allocation for ${beneficiaryType} beneficiaries must equal 100% for Beneficiary #${index + 1}`)
            return true;
        }
        return false;
    };

    const hasEmptyValues = (data) => {
        const requiredFields = [
            "first_name",
            "last_name",
            "middle_name",
            "relation",
            "sin",
            "dob",
            "allocation",
        ];

        return data?.some(row =>
            requiredFields.some(field => row[field] === null || row[field] === "")
        );
    };

    const hasEmptyAccounts = (data) => {

        const isAnyPrimaryChecked = data.primary.some(item =>
            item.bene_register_account_type.some(account => account.account_checked === true)
        );

        const isAnySpouseChecked = data.spouse.some(item =>
            item.bene_register_account_type.some(account => account.account_checked === true)
        );

        return !(isAnyPrimaryChecked || isAnySpouseChecked);
    };

    const saveContingentBeneficiary = async (index) => {

        const accountDetails = Array.isArray(beneficiaryData?.elect_contingent_account_beneficiary_details)
            ? beneficiaryData.elect_contingent_account_beneficiary_details[index]?.details
            : [];

        const accountBeneDetails = Array.isArray(beneficiaryData?.elect_contingent_account_beneficiary_details)
            ? beneficiaryData.elect_contingent_account_beneficiary_details[index]
            : [];

        if (beneficiaryData.elect_contingent_beneficiary == 1 && hasEmptyValues(accountDetails)) {
            toast.error('Please fill in all beneficiary details.');
            return false;
        }

        if (beneficiaryData.elect_contingent_beneficiary == 1 && hasEmptyAccounts(accountBeneDetails)) {
            toast.error('Please select at least one account type for contingent beneficiaries.');
            return false;
        }

        const validationError = validateAllocations(accountDetails, index, 2);

        if (!validationError) {

            let endPoint = `api/save-user-contingent-beneficiary-info`;

            const submitData = { ...beneficiaryData.elect_contingent_account_beneficiary_details[index], login_id: formAccountData.login_id, accountTypeId: accountTypeId, user_id: userId ? userId : 0 }

            try {
                const response = await axiosInstance.post(endPoint, submitData);

                if (response.status === 200) {
                    // setActiveAccountStep(modifiedChildStep);
                    fetchAllApi()
                }

            } catch (error) {
                // console.error(error)
            }
        }
    }

    const saveBeneficiary = async (index) => {

        const accountDetails = Array.isArray(beneficiaryData?.elect_account_beneficiary_details)
            ? beneficiaryData.elect_account_beneficiary_details[index]?.details
            : [];

        const accountBeneDetails = Array.isArray(beneficiaryData?.elect_account_beneficiary_details)
            ? beneficiaryData.elect_account_beneficiary_details[index]
            : [];

        if (beneficiaryData.elect_account_beneficiary == 1 && hasEmptyValues(accountDetails)) {
            toast.error('Please fill in all beneficiary details.');
            return false;
        }

        // make sure every beneficiary have an account al least one.
        if (beneficiaryData.elect_account_beneficiary == 1 && hasEmptyAccounts(accountBeneDetails)) {
            toast.error('Please select at least one account type for primary beneficiaries.');
            return false;
        }

        const validationError = validateAllocations(accountDetails, index, 1);

        if (!validationError) {

            /* setFormAccountData(prevData => ({
                ...prevData,
                beneficiary_details: beneficiaryData
            })); */

            showLoader()

            let endPoint = `api/save-user-beneficiary-info`;

            const submitData = { ...beneficiaryData.elect_account_beneficiary_details[index], login_id: formAccountData.login_id, accountTypeId: accountTypeId, user_id: userId ? userId : 0 }

            try {
                const response = await axiosInstance.post(endPoint, submitData);

                if (response.status === 200) {
                    // setActiveAccountStep(modifiedChildStep);
                    fetchAllApi()
                }

            } catch (error) {
                // console.error(error)
            }
        }

        hideLoader()
    }

    const submitForm = async () => {

        setFormAccountData(prevData => ({
            ...prevData,
            beneficiary_details: beneficiaryData
        }));

        let modifiedChildStep = activeAccountStep + 1

        // id account transfer is no then skip Transfer details form step.
        if (formAccountData.account_transfer == 2) {
            modifiedChildStep = activeAccountStep + 2
        }


        let endPoint = `api/change-beneficiary-select-data`;

        const submitData = {
            elect_account_beneficiary: beneficiaryData?.elect_account_beneficiary,
            elect_contingent_beneficiary: beneficiaryData?.elect_contingent_beneficiary,
            user_id: userId ? userId : 0,
            parent_step: 1,
            child_step: modifiedChildStep
        }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.success) {
                setActiveAccountStep(modifiedChildStep);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    }

    const handleRoleBack = async () => {

        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: activeAccountStep - 1 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(activeAccountStep - 1);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    };


    const fetchAllApi = async () => {
        try {
            showLoader()
            await fetchBeneficiaryData()
            hideLoader()

        } catch (error) {
            hideLoader()
        }
    }

    useEffect(() => {
        fetchAllApi()
    }, [])


    return (
        <div className='container  mt-5'>
            <form onSubmit={handleSubmit(submitForm)}>

                <div className="beneficiary-box">
                    <Grid item className='d-flex'>

                        <Grid item xs={12} sm={6} md={6} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                            <label htmlFor="elect-beneficiary" className='font15px'>Does the account holder wish to elect Beneficiaries for this account?</label>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} className='margin-left10px'>
                            <FormControl component='fieldset' error={Boolean(errors.elect_account_beneficiary)}>
                                <RadioGroup
                                    row
                                    name="elect_account_beneficiary"
                                    id='elect-beneficiary'
                                    value={beneficiaryData?.elect_account_beneficiary || ''}
                                >
                                    {radioOptionArray.map((row) => (
                                        <FormControlLabel
                                            key={row.value}
                                            value={row.value}
                                            control={
                                                <Radio
                                                    sx={radioColorSx}
                                                    {...register('elect_account_beneficiary', {
                                                        required: true,
                                                        onChange: (e) => {
                                                            handleChange(e, 'elect_account_beneficiary_details');
                                                            // setShowAccountBeneficiaryDetails(e.target.value === '1'); // Update showAccountBeneficiaryDetails
                                                        },
                                                    })}
                                                />
                                            }
                                            label={row.label}
                                        />
                                    ))}
                                </RadioGroup>
                                <FormHelperText>
                                    {errors.elect_account_beneficiary && 'Please Select Beneficiary'}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {(beneficiaryData?.elect_account_beneficiary == 1) && (
                        <>
                            <div className='padding10px width100'>

                                {beneficiaryData?.elect_account_beneficiary_details.map((beneficiary, index) => {

                                    return (
                                        <>
                                            {/* ----------person account details ------------- */}

                                            <Grid
                                                xs={12} sm={12} md={12}
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                className='form-head-gray-title mt-2 d-flex'
                                            >

                                                <Grid item>
                                                    <Typography component={'h3'}>Beneficiary Details #{index + 1}</Typography>
                                                </Grid>

                                                {(index > 0) &&
                                                    <Grid item>
                                                        <IconButton onClick={() => removeAccountBeneficiary(index, beneficiary.id)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Grid>
                                                }
                                            </Grid>

                                            <Grid container spacing={2}>
                                                {(beneficiary.primary_non_reg_count > 0 || beneficiary.primary_reg_count > 0) &&
                                                    <Grid item xs={12} sm={12} md={12} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                                                        <label htmlFor="elect-beneficiary" className='label-text'>Primary's account</label>
                                                    </Grid>
                                                }

                                                {/*  <Grid item xs={6}>
                                                    {(beneficiary.primary_non_reg_count > 0) && (<>
                                                        <label className="font18px">Non-Registered Account</label>
                                                        {beneficiary.primary.map((primaryItem, idx) => (
                                                            <div key={idx} className='p-1'>
                                                                {primaryItem.bene_non_register_account_type.map((itemRow, pRegItemRowIndex) => (
                                                                    <div key={pRegItemRowIndex}>
                                                                        <div className="d-flex ml-10px" key={itemRow.value}>
                                                                            <input
                                                                                type="checkbox"
                                                                                className="asset_checkbox-1 width16px"
                                                                                id={`p_account_non_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                checked={itemRow.account_checked || false} // Ensure a default value
                                                                                onChange={() =>
                                                                                    handleAccountTypeChange(
                                                                                        "primary",
                                                                                        "bene_non_register_account_type",
                                                                                        idx,
                                                                                        pRegItemRowIndex,
                                                                                        index
                                                                                    )
                                                                                }
                                                                                
                                                                            />
                                                                            <label
                                                                                htmlFor={`p_account_non_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                className='account-label-text'
                                                                            >
                                                                                {itemRow.label}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ))}
                                                    </>
                                                    )}
                                                </Grid>
                                                 */}

                                                <Grid item xs={6}>
                                                    {(beneficiary.primary_reg_count > 0) && (
                                                        <>
                                                            <label className="font18px">Registered Account</label>
                                                            {beneficiary.primary?.map((item, bRegPersonIndex) => (
                                                                <div key={bRegPersonIndex} className="beneficiary-section p-1">

                                                                    {item.bene_register_account_type?.map((itemRow, pRegItemRowIndex) => (
                                                                        <div className="d-flex ml-10px" key={itemRow.value}>
                                                                            <input
                                                                                type="checkbox"
                                                                                className="asset_checkbox-1 width16px"
                                                                                id={`p_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                checked={itemRow.account_checked || false} // Ensure a default value
                                                                                onChange={() =>
                                                                                    handleAccountTypeChange(
                                                                                        "primary",
                                                                                        "bene_register_account_type",
                                                                                        bRegPersonIndex,
                                                                                        pRegItemRowIndex,
                                                                                        index
                                                                                    )
                                                                                }

                                                                            />
                                                                            <label
                                                                                htmlFor={`p_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                className='account-label-text'
                                                                            >
                                                                                {itemRow.label}
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid >

                                            <Divider className='divider' />
                                            {/* ----------spouse account details ------------- */}
                                            <Grid container spacing={2} className='mt-3'>

                                                {(beneficiary.spousal_non_reg_count > 0 || beneficiary.spousal_reg_count > 0) &&
                                                    <Grid item xs={12} sm={12} md={12} className={`align-content-center pt-0 ${matchesMD ? '' : 'text-left'}`}>
                                                        <label htmlFor="elect-beneficiary" className='label-text'>Spouse's account</label>
                                                    </Grid>
                                                }


                                                {/*  <Grid item xs={6}>
                                                    {beneficiary.spousal_non_reg_count > 0 && (
                                                        <>
                                                            <label className="font18px">Non-Registered Account</label>
                                                            {beneficiary.spouse.map((primaryItem, idx) => (
                                                                <div key={idx} className='p-1'>
                                                                    {primaryItem.bene_non_register_account_type.map((itemRow, pRegItemRowIndex) => (
                                                                        <div key={pRegItemRowIndex}>
                                                                            <div className="d-flex ml-10px" key={itemRow.value}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="asset_checkbox-1"
                                                                                    id={`s_account_non_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                    checked={itemRow.account_checked || false}
                                                                                    onChange={() =>
                                                                                        handleAccountTypeChange(
                                                                                            "spouse",
                                                                                            "bene_non_register_account_type",
                                                                                            idx,
                                                                                            pRegItemRowIndex,
                                                                                            index
                                                                                        )
                                                                                    }
                                                                                    sx={{ width: '16px' }}
                                                                                />
                                                                                <label
                                                                                    htmlFor={`s_account_non_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                    sx={{ width: '160px', fontSize: '16px', margin: '10px' }}
                                                                                >
                                                                                    {itemRow.label}
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </Grid> */}

                                                <Grid item xs={6}>
                                                    {beneficiary.spousal_reg_count > 0 && (
                                                        <>
                                                            <label className="font18px">Registered Account</label>
                                                            {beneficiary.spouse?.map((item, bRegPersonIndex) => (
                                                                <div key={bRegPersonIndex} className="beneficiary-section  p-1">

                                                                    {item.bene_register_account_type?.map((itemRow, pRegItemRowIndex) => (
                                                                        <div className="d-flex ml-10px" key={itemRow.value}>
                                                                            <input
                                                                                type="checkbox"
                                                                                className="asset_checkbox-1 width16px"
                                                                                id={`s_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                checked={itemRow.account_checked || false} // Ensure a default value
                                                                                onChange={() =>
                                                                                    handleAccountTypeChange(
                                                                                        "spouse",
                                                                                        "bene_register_account_type",
                                                                                        bRegPersonIndex,
                                                                                        pRegItemRowIndex,
                                                                                        index
                                                                                    )
                                                                                }
                                                                                
                                                                            />
                                                                            <label
                                                                                htmlFor={`s_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                className='account-label-text'
                                                                            >
                                                                                {itemRow.label}
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            {
                                                beneficiary?.details?.map((row, dIndex) => {

                                                    return (
                                                        <>
                                                            <Grid
                                                                xs={12} sm={12} md={12}
                                                                direction="row"
                                                                justifyContent="space-between"
                                                                alignItems="center"
                                                                className='form-head-gray-title mt-2 d-flex'
                                                            >
                                                                <Grid item>
                                                                    <Typography component={'h3'}>Beneficiary Member #{dIndex + 1}</Typography>
                                                                </Grid>
                                                                {(dIndex > 0) &&

                                                                    <Grid item>
                                                                        <IconButton className='p-0' onClick={() => removeAccountMember(row.id, index, dIndex)}>
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </Grid>
                                                                }
                                                            </Grid>

                                                            <Grid container spacing={2} className='mt-2'>

                                                                {(index >= 1) && (
                                                                    <>
                                                                        <Grid item xs={4} className='align-content-center'>
                                                                            <Typography component={'h3'}>Select Beneficiary</Typography>
                                                                        </Grid>

                                                                        <Grid item xs={8}>
                                                                            <FormControl fullWidth size="small">
                                                                                <InputLabel>Select Beneficiary</InputLabel>
                                                                                <Select
                                                                                    value={row.selected_beneficiary_member || ''}
                                                                                    label="Select Beneficiary"
                                                                                    MenuProps={{
                                                                                        disableScrollLock: true,
                                                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                                                    }}
                                                                                    onChange={(e) => handleChangeAccountMember(index, dIndex, "selected_beneficiary_member", e.target.value)}
                                                                                >
                                                                                    {accountMemberData?.map((option) => (
                                                                                        <MenuItem key={option.id} value={option.id}>
                                                                                            {option.full_name}
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>
                                                                    </>
                                                                )}
                                                                <Grid item xs={6}>
                                                                    <TextField
                                                                        label="First Name"
                                                                        fullWidth
                                                                        size="small"
                                                                        value={row.first_name || ''}
                                                                        onChange={(e) => handleInputChange(index, dIndex, "first_name", e.target.value)} />
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextField
                                                                        label="Middle Initial"
                                                                        fullWidth
                                                                        size="small"
                                                                        value={row.middle_name || ''}
                                                                        onChange={(e) => handleInputChange(index, dIndex, "middle_name", e.target.value)} />
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextField
                                                                        label="Last Name"
                                                                        fullWidth
                                                                        size="small"
                                                                        value={row.last_name || ''}
                                                                        onChange={(e) => handleInputChange(index, dIndex, "last_name", e.target.value)} />
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <TextField
                                                                        label="SIN"
                                                                        fullWidth
                                                                        size="small"
                                                                        value={row.sin || ''}
                                                                        onChange={(e) => handleInputChange(index, dIndex, "sin", e.target.value)} />
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            label="Date of Birth"
                                                                            inputFormat="yyyy/MM/dd"
                                                                            value={row.dob || null}
                                                                            onChange={(date) => handleBeneficiaryDateChange(index, date, dIndex)}
                                                                            renderInput={(params) => <TextField {...params} fullWidth size="small" />} />
                                                                    </LocalizationProvider>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <NumberFormat
                                                                        customInput={TextField}
                                                                        label="Allocation (%)"
                                                                        suffix="%"
                                                                        value={row.allocation}
                                                                        fullWidth
                                                                        size="small"
                                                                        onValueChange={(values) => handleAllocationChange(index, values, dIndex)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <FormControl fullWidth size="small">
                                                                        <InputLabel>Relationship</InputLabel>
                                                                        <Select
                                                                            value={row.relation || ''}
                                                                            label="Relationship"
                                                                            MenuProps={{
                                                                                disableScrollLock: true,
                                                                                PaperProps: { sx: { maxHeight: 200 } }
                                                                            }}
                                                                            onChange={(e) => handleInputChange(index, dIndex, "relation", e.target.value)}
                                                                        >
                                                                            {relationArray.map((option) => (
                                                                                <MenuItem key={option.value} value={option.value}>
                                                                                    {option.label}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    )
                                                })
                                            }

                                            <Grid container spacing={2} className='mt-1'>

                                                <Grid item xs={6}>

                                                    {/* member only enter from beneficiary #1 */}
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => addAccountBeneficiaryDetails(index)}
                                                    >
                                                        Add Member
                                                    </Button>
                                                </Grid>

                                                <Grid item xs={6} className='text-right'>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => saveBeneficiary(index)}
                                                    >
                                                        Save
                                                    </Button>
                                                </Grid>
                                            </Grid>

                                        </>
                                    )
                                })}
                                {/* <Divider className='divider' /> */}
                            </div>
                            <Grid item xs={12}>
                                <Button
                                    startIcon={<AddIcon />}
                                    // disabled={!beneficiaryData.is_exists_beneficiary_account_data}
                                    disabled={beneficiaryData.elect_account_beneficiary_details.length >= 4}
                                    onClick={addAccountBeneficiary}
                                >
                                    Add Beneficiary
                                </Button>
                            </Grid>
                        </>
                    )}
                </div>

                <div className="beneficiary-box">
                    <div className='d-flex'>
                        <Grid item xs={12} sm={6} md={6} className={`align-content-center ${matchesMD ? '' : 'text-left'}`}>
                            <label htmlFor="elect-beneficiary" className='font15px'> Does the account holder wish to elect Contingent Beneficiaries for this account?</label>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} className='margin-left10px'>
                            <FormControl component='fieldset' error={Boolean(errors.elect_contingent_beneficiary)}>
                                <RadioGroup
                                    row
                                    name="elect_contingent_beneficiary"
                                    id='elect-beneficiary'
                                    value={beneficiaryData?.elect_contingent_beneficiary || ''}
                                >
                                    {radioOptionArray.map((row) => (
                                        <FormControlLabel
                                            key={row.value}
                                            value={row.value}
                                            control={
                                                <Radio
                                                    sx={radioColorSx}
                                                    {...register('elect_contingent_beneficiary', {
                                                        required: true,
                                                        onChange: (e) => {
                                                            handleChange(e, 'elect_contingent_account_beneficiary_details');
                                                            // setShowAccountBeneficiaryDetails(e.target.value === '1'); // Update showAccountBeneficiaryDetails
                                                        },
                                                    })}
                                                />
                                            }
                                            label={row.label}
                                        />
                                    ))}
                                </RadioGroup>
                                <FormHelperText>
                                    {errors.elect_contingent_beneficiary && 'Please Select Beneficiary'}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                    </div>

                    {(beneficiaryData?.elect_contingent_beneficiary == 1) && (
                        <>
                            <div className='padding10px width100'>

                                {beneficiaryData?.elect_contingent_account_beneficiary_details.map((beneficiary, index) => {

                                    return (
                                        <>

                                            {/* ----------person account details ------------- */}
                                            <Grid
                                                xs={12} sm={12} md={12}
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                className='form-head-gray-title mt-2 d-flex'
                                            >
                                                <Grid item>
                                                    <Typography component={'h3'}>Beneficiary Details #{index + 1}</Typography>
                                                </Grid>

                                                {(index > 0) &&
                                                    <Grid item>
                                                        <IconButton onClick={() => removeContingentAccountBeneficiary(index, beneficiary.id)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Grid>
                                                }

                                            </Grid>


                                            <Grid container spacing={2} className='mt-3'>
                                                {(beneficiary.primary_non_reg_count > 0 || beneficiary.primary_reg_count > 0) &&
                                                    <Grid item xs={12} sm={12} md={12} className={`align-content-center  ${matchesMD ? '' : 'text-left'}`}>
                                                        <label htmlFor="primary-elect-beneficiary" className='label-text'>Primary's account</label>
                                                    </Grid>
                                                }

                                                {/* <Grid item xs={6}>
                                                    {(beneficiary.primary_non_reg_count > 0) &&
                                                        (
                                                            <>
                                                                <label className="font18px">Non-Registered Account</label>
                                                                {beneficiary.primary.map((primaryItem, idx) => (
                                                                    <div key={idx} className='p-1'>
                                                                        {primaryItem.bene_non_register_account_type.map((itemRow, pRegItemRowIndex) => (
                                                                            <div key={pRegItemRowIndex}>
                                                                                <div className="d-flex ml-10px" key={itemRow.value}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="asset_checkbox-1 width16px"
                                                                                        id={`p_contingent_account_non_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                        checked={itemRow.account_checked || false} // Ensure a default value
                                                                                        onChange={(e) =>
                                                                                            handleContingentAccountTypeChange(
                                                                                                e,
                                                                                                "primary",
                                                                                                "bene_non_register_account_type",
                                                                                                idx,
                                                                                                pRegItemRowIndex,
                                                                                                index
                                                                                            )
                                                                                        }
                                                                                        
                                                                                    />
                                                                                    <label
                                                                                        htmlFor={`p_contingent_account_non_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                        className='account-label-text'
                                                                                    >
                                                                                        {itemRow.label}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        ))}

                                                                    </div>
                                                                ))}
                                                            </>
                                                        )}
                                                </Grid> */}

                                                <Grid item xs={6}>
                                                    {(beneficiary.primary_reg_count > 0) &&
                                                        (
                                                            <>
                                                                <label className="font18px">Registered Account</label>
                                                                {beneficiary.primary?.map((item, bRegPersonIndex) => (
                                                                    <div key={bRegPersonIndex} className="beneficiary-section  p-1">

                                                                        {item.bene_register_account_type?.map((itemRow, pRegItemRowIndex) => (
                                                                            <div className="d-flex ml-10px" key={itemRow.value}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="asset_checkbox-1 width16px"
                                                                                    id={`p_contingent_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                    checked={itemRow.account_checked || false} // Ensure a default value
                                                                                    onChange={(e) =>
                                                                                        handleContingentAccountTypeChange(
                                                                                            e,
                                                                                            "primary",
                                                                                            "bene_register_account_type",
                                                                                            bRegPersonIndex,
                                                                                            pRegItemRowIndex,
                                                                                            index
                                                                                        )
                                                                                    }
                                                                                    
                                                                                />
                                                                                <label
                                                                                    htmlFor={`p_contingent_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                    className='account-label-text'
                                                                                >
                                                                                    {itemRow.label}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                ))}
                                                            </>
                                                        )}
                                                </Grid>
                                            </Grid>

                                            <Divider className='divider' />

                                            {/* ----------spouse account details ------------- */}
                                            <Grid container spacing={2} className='mt-3'>

                                                {(beneficiary.spousal_non_reg_count > 0 || beneficiary.spousal_reg_count > 0) &&
                                                    <Grid item xs={12} sm={12} md={12} className={`align-content-center pt-0 ${matchesMD ? '' : 'text-left'}`}>
                                                        <label htmlFor="spouse-elect-beneficiary" className='label-text'>Spouse's account</label>
                                                    </Grid>
                                                }

                                                {/* <Grid item xs={6}>
                                                    {(beneficiary.spousal_non_reg_count > 0) && (<>
                                                        <label className="font18px">Non-Registered Account</label>
                                                        {beneficiary.spouse.map((primaryItem, idx) => (
                                                            <div key={idx} className='p-1'>
                                                                {primaryItem.bene_non_register_account_type.map((itemRow, pRegItemRowIndex) => (
                                                                    <div key={pRegItemRowIndex}>
                                                                        <div className="d-flex ml-10px" key={itemRow.value}>
                                                                            <input
                                                                                type="checkbox"
                                                                                className="asset_checkbox-1 width16px"
                                                                                id={`s_contingent_account_non_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                checked={itemRow.account_checked || false} // Ensure a default value
                                                                                onChange={(e) =>
                                                                                    handleContingentAccountTypeChange(
                                                                                        e,
                                                                                        "spouse",
                                                                                        "bene_non_register_account_type",
                                                                                        idx,
                                                                                        pRegItemRowIndex,
                                                                                        index
                                                                                    )
                                                                                }
                                                                                
                                                                            />
                                                                            <label
                                                                                htmlFor={`s_contingent_account_non_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                className='account-label-text'
                                                                            >
                                                                                {itemRow.label}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                ))}

                                                            </div>
                                                        ))}
                                                    </>
                                                    )}
                                                </Grid> */}

                                                <Grid item xs={6}>
                                                    {(beneficiary.spousal_reg_count > 0) && (
                                                        <>
                                                            <label className="font18px">Registered Account</label>
                                                            {beneficiary.spouse?.map((item, bRegPersonIndex) => (
                                                                <div key={bRegPersonIndex} className="beneficiary-section p-1">

                                                                    {item.bene_register_account_type?.map((itemRow, pRegItemRowIndex) => (
                                                                        <div className="d-flex ml-10px" key={itemRow.value}>
                                                                            <input
                                                                                type="checkbox"
                                                                                className="asset_checkbox-1 width16px"
                                                                                id={`s_contingent_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                checked={itemRow.account_checked || false} // Ensure a default value
                                                                                onChange={(e) =>
                                                                                    handleContingentAccountTypeChange(
                                                                                        e,
                                                                                        "spouse",
                                                                                        "bene_register_account_type",
                                                                                        bRegPersonIndex,
                                                                                        pRegItemRowIndex,
                                                                                        index
                                                                                    )
                                                                                }
                                                                            />
                                                                            <label
                                                                                htmlFor={`s_contingent_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                className='account-label-text'
                                                                            >
                                                                                {itemRow.label}
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>


                                            {beneficiary?.details?.map((row, dIndex) => {
                                                return (
                                                    <>

                                                        <Grid
                                                            xs={12} sm={12} md={12}
                                                            direction="row"
                                                            justifyContent="space-between"
                                                            alignItems="center"
                                                            className='form-head-gray-title mt-2 d-flex'
                                                        >
                                                            <Grid item>
                                                                <Typography component={'h3'}>Beneficiary Member #{dIndex + 1}</Typography>
                                                            </Grid>

                                                            {(dIndex > 0) &&
                                                                <Grid item>
                                                                    <IconButton className='p-0' onClick={() => removeContingentAccountMember(row.id, index, dIndex)}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </Grid>
                                                            }
                                                        </Grid>

                                                        <Grid container spacing={2} className='mt-2'>
                                                            {(index >= 1) && (
                                                                <>
                                                                    <Grid item xs={4} className='align-content-center'>
                                                                        <Typography component={'h3'}>Select Beneficiary</Typography>
                                                                    </Grid>

                                                                    <Grid item xs={8}>
                                                                        <FormControl fullWidth size="small">
                                                                            <InputLabel>Select Beneficiary</InputLabel>
                                                                            <Select
                                                                                value={row.selected_beneficiary_member || ''}
                                                                                label="Select Beneficiary"
                                                                                MenuProps={{
                                                                                    disableScrollLock: true,
                                                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                                                }}
                                                                                onChange={(e) => handleChangeContingentAccountMember(index, dIndex, "selected_beneficiary_member", e.target.value)}
                                                                            >
                                                                                {contingentAccountMemberData?.map((option) => (
                                                                                    <MenuItem key={option.id} value={option.id}>
                                                                                        {option.full_name}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                        </FormControl>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    label="First Name"
                                                                    fullWidth
                                                                    size="small"
                                                                    value={row.first_name || ''}
                                                                    onChange={(e) => handleContingentInputChange(index, dIndex, "first_name", e.target.value)} />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    label="Middle Initial"
                                                                    fullWidth
                                                                    size="small"
                                                                    value={row.middle_name || ''}
                                                                    onChange={(e) => handleContingentInputChange(index, dIndex, "middle_name", e.target.value)} />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    label="Last Name"
                                                                    fullWidth
                                                                    size="small"
                                                                    value={row.last_name || ''}
                                                                    onChange={(e) => handleContingentInputChange(index, dIndex, "last_name", e.target.value)} />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    label="SIN"
                                                                    fullWidth
                                                                    size="small"
                                                                    value={row.sin || ''}
                                                                    onChange={(e) => handleContingentInputChange(index, dIndex, "sin", e.target.value)} />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                    <DesktopDatePicker
                                                                        label="Date of Birth"
                                                                        inputFormat="yyyy/MM/dd"
                                                                        value={row.dob || null}
                                                                        onChange={(date) => handleContingentBeneficiaryDateChange(index, date, dIndex)}
                                                                        renderInput={(params) => <TextField {...params} fullWidth size="small" />} />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <NumberFormat
                                                                    customInput={TextField}
                                                                    label="Allocation (%)"
                                                                    suffix="%"
                                                                    value={row.allocation}
                                                                    fullWidth
                                                                    size="small"
                                                                    onValueChange={(values) => handleContingentAllocationChange(index, values, dIndex)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <FormControl fullWidth size="small">
                                                                    <InputLabel>Relationship</InputLabel>
                                                                    <Select
                                                                        value={row.relation || ''}
                                                                        label="Relationship"
                                                                        MenuProps={{
                                                                            disableScrollLock: true,
                                                                            PaperProps: { sx: { maxHeight: 200 } }
                                                                        }}
                                                                        // inputProps={register('bene_relation', {
                                                                        //     onChange: (e) => handleContinentBeneficiaryChange(e.target.value, contingentBeneficiaryIndex, 'bene_relation'),
                                                                        //     required: true
                                                                        // })}
                                                                        onChange={(e) => handleContingentInputChange(index, dIndex, "relation", e.target.value)}
                                                                    >
                                                                        {relationArray.map((option) => (
                                                                            <MenuItem key={option.value} value={option.value}>
                                                                                {option.label}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                )
                                            })}
                                            <Grid container spacing={2} className='mt-1'>


                                                <Grid item xs={6} className='mt-1'>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => addContingentBeneficiaryDetails(index)}
                                                    >
                                                        Add Member
                                                    </Button>
                                                </Grid>

                                                <Grid item xs={6} className='text-right'>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => saveContingentBeneficiary(index)}
                                                    >
                                                        Save
                                                    </Button>
                                                </Grid>
                                            </Grid>

                                        </>
                                    )
                                })}
                                {/* <Divider className='divider' /> */}
                            </div>
                            <Grid item xs={12}>
                                <Button
                                    startIcon={<AddIcon />}
                                    // disabled={!beneficiaryData.is_exists_beneficiary_contingent_account_data}
                                    disabled={beneficiaryData.elect_contingent_account_beneficiary_details.length >= 4}
                                    onClick={addContingentAccountBeneficiary}
                                >
                                    Add Beneficiary
                                </Button>
                            </Grid>
                        </>
                    )}

                </div>

                <Grid item xs={12} sm={6} className='text-center'>
                    <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid >

            </form >
            {loader}
            < ToastContainer />
        </div >
    )
}

export default BeneficiaryInformation